import { defineStore } from 'pinia';

export const usePdfViewerStore = defineStore('pdfViewer', {
  state: () => ({
    viewPdf: false as boolean,
    src: '' as string,
    pdfName: '' as string,
    isPdf: false as boolean
  }),
  actions: {
    resetPDFViewerInputs() {
      this.viewPdf = false;
      this.src = '';
      this.pdfName = '';
      this.isPdf = false;
    }
  }
});
